<template>
  <div class="create-file" v-show="seen">
    <div class="invite">
      <div class="title d-flex justify-content-between">
        <h4>Invite people</h4>
        <span @click="close" class="close_advanced_search">
          <close />
        </span>
      </div>
      <div class="">
        <p class="invite-label">Send invite to:</p>
        <label class="email-box-holder">
          <div class="email-box">
            <span v-for="(el, index) of emailsToSendLink" :key="index">{{ el }}&nbsp;&nbsp;
              <svg
                class="p-cursor"
                title="Remove"
                @click="removeEmailsToSendLink(el)"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.14398 0.757812L4.96173 3.93931L1.78023 0.757812L0.719727 1.81831L3.90123 4.99981L0.719727 8.18131L1.78023 9.24181L4.96173 6.06031L8.14398 9.24181L9.20448 8.18131L6.02298 4.99981L9.20448 1.81831L8.14398 0.757812Z"
                  fill="#4B5458"
                />
              </svg>
            </span>
            <input v-model="emailLink" ref="file" placeholder="name@example.com" @keypress="setEmailsToSendLink"/>
          </div>
        </label>
        <p class="invite-text">
          You can invite multiple email. Use comma to separate multitple
          email addresses, example: <span><strong>name@example.com</strong></span>,
          <span><strong>name2@example.com</strong></span>
        </p>
        <p class="make-public">
          <template v-if="$store.getters.ACCT_TYPE == 2 && $store.getters.ISADMIN">
          <label class="font-weight-normal">
            <input
              type="checkbox"
              v-model="type"
              class="mr-1 d-inline"
              style="width: auto;"
            /><span>Make user public to everyone in your organzition?</span></label
          >
        </template>
        </p>
        <div class="btnn">
          <template v-if="!loader">
            <span @click="send" class="send" :class="{'cursor-pointer': emailsToSendLink.length || validateEmail(emailLink), 'cursor-not-allowed': !emailsToSendLink.length && !validateEmail(emailLink)}">Send Invitation</span>
          </template>
          <template v-else>
            <span class="send cursor-not-allowed">Please wait...</span>
          </template>
          <span class="copy-text" @click="copylink">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-26fe4259=""><path d="M17.5 7.45033C17.4913 7.37377 17.4746 7.29835 17.45 7.22533V7.15033C17.4099 7.06464 17.3565 6.98588 17.2917 6.91699L12.2917 1.91699C12.2228 1.85217 12.144 1.79873 12.0583 1.75866C12.0335 1.75513 12.0082 1.75513 11.9833 1.75866C11.8987 1.71011 11.8052 1.67895 11.7083 1.66699H8.33333C7.67029 1.66699 7.03441 1.93038 6.56557 2.39923C6.09673 2.86807 5.83333 3.50395 5.83333 4.16699V5.00033H5C4.33696 5.00033 3.70107 5.26372 3.23223 5.73256C2.76339 6.2014 2.5 6.83728 2.5 7.50033V15.8337C2.5 16.4967 2.76339 17.1326 3.23223 17.6014C3.70107 18.0703 4.33696 18.3337 5 18.3337H11.6667C12.3297 18.3337 12.9656 18.0703 13.4344 17.6014C13.9033 17.1326 14.1667 16.4967 14.1667 15.8337V15.0003H15C15.663 15.0003 16.2989 14.7369 16.7678 14.2681C17.2366 13.7993 17.5 13.1634 17.5 12.5003V7.50033C17.5 7.50033 17.5 7.50033 17.5 7.45033ZM12.5 4.50866L14.6583 6.66699H13.3333C13.1123 6.66699 12.9004 6.5792 12.7441 6.42291C12.5878 6.26663 12.5 6.05467 12.5 5.83366V4.50866ZM12.5 15.8337C12.5 16.0547 12.4122 16.2666 12.2559 16.4229C12.0996 16.5792 11.8877 16.667 11.6667 16.667H5C4.77899 16.667 4.56702 16.5792 4.41074 16.4229C4.25446 16.2666 4.16667 16.0547 4.16667 15.8337V7.50033C4.16667 7.27931 4.25446 7.06735 4.41074 6.91107C4.56702 6.75479 4.77899 6.66699 5 6.66699H5.83333V12.5003C5.83333 13.1634 6.09673 13.7993 6.56557 14.2681C7.03441 14.7369 7.67029 15.0003 8.33333 15.0003H12.5V15.8337ZM15.8333 12.5003C15.8333 12.7213 15.7455 12.9333 15.5893 13.0896C15.433 13.2459 15.221 13.3337 15 13.3337H8.33333C8.11232 13.3337 7.90036 13.2459 7.74408 13.0896C7.5878 12.9333 7.5 12.7213 7.5 12.5003V4.16699C7.5 3.94598 7.5878 3.73402 7.74408 3.57774C7.90036 3.42146 8.11232 3.33366 8.33333 3.33366H10.8333V5.83366C10.8333 6.4967 11.0967 7.13259 11.5656 7.60143C12.0344 8.07027 12.6703 8.33366 13.3333 8.33366H15.8333V12.5003Z" fill="#3F96D1" data-v-26fe4259=""></path></svg>
            <span>Copy invitation link</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.send.cursor-pointer {
  cursor: pointer;
}

.send.cursor-not-allowed {
  cursor: not-allowed;
}
.font-weight-normal {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.invite-text, .make-public {
  font-family: 'inter';
  color: #677888 !important;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
}

.make-public span {
  line-height: 0;
}
.invite-text span {
  font-weight: 500;
}

.invite-label {
  margin-bottom: 5px;
}

.btnn {
  margin-top: 2.5rem;
  margin-bottom: 1rem;
}

.btnn .send {
  padding: 1rem 2rem;
  background: #3f96d1;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1rem;
  color: #fff;
  border-radius: 6px;
  margin-right: 20px;
}

.btnn .copy-text {
  color: #3f96d1;
  cursor: pointer;
}
.title h4 {
  font-weight: 600;
  font-size: 1.25rem;
  color: #111;
}

.title {
  margin-bottom: 1em;
}
.email-box-holder {
  display: block;
  font-size: 0.875rem;
  color: #4b5458;
  border: 1px solid #a7b9cb;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 16px 24px 16px 16px;
  min-height: 160px;
  margin-bottom: 1rem;
}

.email-box {
  display: flex;
  width: 100%;
  overflow-y: auto;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.email-box input {
  border: none;
  width: 14rem;
  height: 2rem;
  font-size: 1rem;
  padding: 0.5rem 0.25rem;
  margin: 0;
  background: #fff;
}

.email-box span {
  border-radius: 0.25rem;
  display: inline-flex;
  align-items: center;
  background-color: #e8f0f6;
  color: #677888;
  line-height: 0;
  height: 2rem;
  font-size: 0.875rem;
  padding: 0.5rem;
  font-weight: 500;
}
.close_advanced_search {
  background: #f2f7fc;
  display: inline-flex;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.invite {
  background: #fff;
  width: 40%;
  border-radius: 6px;
  padding: 1.8rem;
  text-align: left;
  font-family: 'inter-medium';
}
.create-file {
  top: 0 !important;
  z-index: 1000;
}
</style>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'
import axios from 'axios'
import close from '@/components/Icons/Close'
import { validateEmail } from "../utils";

export default {
  components: {
    close
  },
  data () {
    return {
      seen: false,
      title: '',
      filename: '',
      error: false,
      loader: false,
      specialChar_error: '',
      exist: false,
      type: false,
      label_error: false,
      message: '',
      label: '',
      emailsToSend: [],
      emailsToSendLink: [],
      emailLink: "",
    }
  },
  methods: {
    ...mapMutations([
      'SET_FILE_ACTION',
      'REMOVE_FILE_ACTION',
      'SET_DIRECTORY_CHILDREN',
      'TOGGLE_FILE_INFO',
      'UPDATE_DIRECTORY_CHILDREN',
      'SORT_STORED_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'SORT_DIRECTORY_CHILDREN',
      'UPDATE_TOTAL_USED_SPACE'
    ]),
    validateEmail(email) {
      return validateEmail(email)
    },
    copylink() {
      let link = document.querySelector("#referral_link").value;
      let a = document.createElement("input");

      a.setAttribute("value", link);
      a.setAttribute("id", "referallink");
      a.click();
      a.style.position = "absolute";
      a.style.left = "-9999px";
      document.body.appendChild(a);
      let l = document.getElementById("referallink");
      l.select();
      document.execCommand("copy");
      document.body.removeChild(a);

      let that = this;

      that.$toast.open({
        message:
          '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> Referral link copied to clipboard',
        type: "default",
        position: "bottom-right",
      });
    },
    setEmailsToSend(e) {
      if (e.keyCode === 44 || e.keyCode === 32) e.preventDefault();

      if (
        (e.keyCode === 13 || e.keyCode === 44 || e.keyCode === 32) &&
        validateEmail(e.target.value)
      ) {
        if (this.emailsToSend.find((el) => el === e.target.value)) {
          this.$toast.open({
            message: "Email already added",
            type: "default",
            position: "bottom-right",
          });
          return;
        }
        this.emailsToSend.push(e.target.value);
        e.target.value = "";
        this.fileemail = "";
        e.target.focus();
      }
    },
    setEmailsToSendLink(e) {
      if (e.keyCode === 44 || e.keyCode === 32) e.preventDefault();

      if (
        (e.keyCode === 13 || e.keyCode === 44 || e.keyCode === 32) &&
        validateEmail(e.target.value)
      ) {
        if (this.emailsToSendLink.find((el) => el === e.target.value)) {
          this.$toast.open({
            message: "Email already added",
            type: "default",
            position: "bottom-right",
          });
          return;
        }
        this.emailsToSendLink.push(e.target.value);
        e.target.value = "";
        this.emailLink = "";
        e.target.focus();
      }
    },
    removeEmailsToSend(email) {
      this.emailsToSend = this.emailsToSend.filter((el) => el !== email);
    },
    removeEmailsToSendLink(email) {
      this.emailsToSendLink = this.emailsToSendLink.filter(
        (el) => el !== email
      );
    },
    load (type=null) {
      this.seen = true
      this.exist = false
      this.filename = ''
      this.loader = false
      this.emailsToSend = []
      this.emailsToSendLink = []
      this.emailLink = ''
      this.type = false
      this.$nextTick(() => this.$refs.file.focus())

      this.$refs.file.focus()
    },
    send () {
      this.error = false

      if (this.emailsToSendLink.length) {
        if(validateEmail(this.emailLink)) {
          this.emailsToSendLink.push(this.emailLink)
        }
        this.loader = true

        let that = this

        let data = {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          credentials: 'include', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ userId: localStorage.getItem('id'), email: this.emailsToSendLink.join(','), public: this.type }) // body data type must match "Content-Type" header
        }

        fetch(process.env.VUE_APP_INVITE, data)
          .then(response => response.json())
          .then(res => {
            if (res.exists === true) {
              that.loader = false
              that.type = false
              that.seen = false

              that.$toast.open({
                message:
                  '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> An invite link has already been sent',
                type: "default",
                position: "bottom-right",
              });
            } else if (res.sameOrg === true) {
              that.loader = false
              that.type = false
              that.seen = false
              
              that.$toast.open({
                message:
                  '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> You are already in the same organisation',
                type: "default",
                position: "bottom-right",
              });
            } else if (res.isFriend === true) {
              that.loader = false
              that.type = false
              that.seen = false
              
              that.$toast.open({
                message:
                  '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> An invite link has already been sent',
                type: "default",
                position: "bottom-right",
              });
            } else {
              that.loader = false
              that.type = false
              that.seen = false

              let message = that.emailsToSendLink.length == 1? `Invite sent to ${that.emailsToSendLink[0]}` : 'Invite sent'

              that.$toast.open({
                message:
                  `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> ${ message }`,
                type: "default",
                position: "bottom-right",
              });
            }
          })
          .catch(err => {
            that.seen = false
            that.$parent.logincall()
            that.$router.push('/login')
            console.log(err)
          })
      } else {
        if(validateEmail(this.emailLink)) {
          this.loader = true

          let that = this

          let data = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            credentials: 'include', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId: localStorage.getItem('id'), email: this.emailLink, public: this.type }) // body data type must match "Content-Type" header
          }

          fetch(process.env.VUE_APP_INVITE, data)
            .then(response => response.json())
            .then(res => {
              if (res.exists === true) {
                that.loader = false
                that.type = false
                that.seen = false

                that.$toast.open({
                  message:
                    '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> An invite link has already been sent',
                  type: "default",
                  position: "bottom-right",
                });
              } else if (res.sameOrg === true) {
                that.loader = false
                that.type = false
                that.seen = false
                
                that.$toast.open({
                  message:
                    '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> You are already in the same organisation',
                  type: "default",
                  position: "bottom-right",
                });
              } else if (res.isFriend === true) {
                that.loader = false
                that.type = false
                that.seen = false
                
                that.$toast.open({
                  message:
                    '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> An invite link has already been sent',
                  type: "default",
                  position: "bottom-right",
                });
              } else {
                that.loader = false
                that.type = false
                that.seen = false

                let message = `An invite has been sent to ${that.emailLink}`

                that.$toast.open({
                  message:
                    `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> ${ message }`,
                  type: "default",
                  position: "bottom-right",
                });

                that.emailLink = ''
              }
            })
            .catch(err => {
              that.seen = false
              that.$parent.logincall()
              that.$router.push('/login')
              console.log(err)
            })
        }
      }
    },
    close () {
      this.error = ''
      this.filename = ''
      this.specialChar_error = ''
      this.seen = false
      this.loader = false
    }
  }
}
</script>
